import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnterpriseModuleStatus } from 'shared-models';

export interface EnterpriseModuleItem {
  enterpriseId: string;
  moduleId: string | number;
  moduleName?: string;
  price: number;
  configurations: Record<string, unknown>;
  active: boolean;
  status: EnterpriseModuleStatus;
}

export interface UpsertEnterpriseModuleRequest {
  enterpriseId: string;
  moduleId?: string | number;
  moduleName?: string;
  price: number;
  configurations: Record<string, unknown>;
  active: boolean;
  status: EnterpriseModuleStatus;
}

@Injectable({ providedIn: 'root' })
export class EnterpriseModulePreferencesService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = 'enterprise-module';

  getEnterpriseModules(enterpriseId: string): Observable<EnterpriseModuleItem[]> {
    return this.httpClient.get<EnterpriseModuleItem[]>(this.baseUrl, {
      params: { enterpriseId },
    });
  }

  createEnterpriseModule(payload: UpsertEnterpriseModuleRequest): Observable<EnterpriseModuleItem> {
    return this.httpClient.post<EnterpriseModuleItem>(this.baseUrl, payload);
  }

  updateEnterpriseModule(
    enterpriseId: string,
    moduleId: string | number,
    payload: Omit<UpsertEnterpriseModuleRequest, 'enterpriseId' | 'moduleId' | 'moduleName'>
  ): Observable<EnterpriseModuleItem> {
    return this.httpClient.put<EnterpriseModuleItem>(`${this.baseUrl}/${enterpriseId}/${moduleId}`, payload);
  }
}
